import Filter from "../../layouts/Filter";
import AddressInput from "../form-input/address-input/AddressInput";

const MobileFilter = ({
  category,
  brand,
  size,
  gender,
  close,
  sizeFilter,
  genderFilter,
}) => {
  return (
    <section className="block lg:hidden fixed z-40 bg-slate-100 top-0 left-0 w-full h-screen overflow-hidden">
      <div className="flex justify-center flex-wrap gap-3 mt-5">
        <Filter header="Browse Categories">
          {category?.map(({ name, code }) => (
            <button
              key={code}
              className="block border-none outline-none bg-none mt-3"
            >
              {name}
            </button>
          ))}
        </Filter>

        <Filter header="Brand">
          <div className="relative mt-5">
            <input
              type="text"
              className="w-full lg:w-9/10 h-8 border-lightGrey text-sm lg:text-base border rounded-xl pl-8 outline-none"
              placeholder="Search by brand name"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              className="absolute top-2 left-2 bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
            </svg>
          </div>
          <div className="mt-3">
            {brand?.map(({ name, code }) => (
              <div key={code} className="flex items-center gap-3 mt-2">
                <AddressInput value={code} name="brand" />
                <div className="font-normal text-sm">{name}</div>
              </div>
            ))}
          </div>
        </Filter>

        {/* price range here */}

        <Filter header="Size">
          <div className="mt-3">
            {size?.map(({ name, code }) => (
              <div key={code} className="flex items-center gap-3 mt-2">
                <AddressInput value={code} name="size" onchange={sizeFilter} />
                <div className="font-normal text-sm">{name}</div>
              </div>
            ))}
          </div>
        </Filter>

        <Filter header="Gender">
          <div className="mt-3">
            {gender?.map(({ name, code }) => (
              <div key={code} className="flex items-center gap-3 mt-2">
                <AddressInput
                  value={code}
                  name="gender"
                  onchange={genderFilter}
                />
                <div className="font-normal text-sm">{name}</div>
              </div>
            ))}
          </div>
        </Filter>
      </div>

      <div className="flex gap-5 justify-center items-center mt-5 md:12">
        <button
          className="h-12 w-favImg bg-logoRed border border-logoRed text-white font-bold outline-none"
          onClick={() => close(false)}
        >
          Apply filter
        </button>
        <button
          className="h-12 w-favImg bg-white border border-logoRed text-logoRed outline-none"
          onClick={() => close(false)}
        >
          Close
        </button>
      </div>
    </section>
  );
};

export default MobileFilter;
